import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useQueryStates } from 'nuqs'
import { parseAsInteger, parseAsString } from 'nuqs'
import { useDebounceValue } from 'usehooks-ts'
import useQueryGetShopPurchases from '@/modules/shop/api/hooks/useQueryGetShopPurchases'
import PurchasesListing from '@/modules/shop/components/PurchasesListing'
import { components, ShopHistoryStatus } from '@/schema'

function PendingPurchasesPage() {
	const [queryParams] = useQueryStates({
		page: parseAsInteger.withOptions({ shallow: false }).withDefault(1),
		limit: parseAsInteger.withOptions({ shallow: false }).withDefault(10),
		q: parseAsString.withOptions({ shallow: false }).withDefault(''),
		rewardType: parseAsString.withOptions({ shallow: false }).withDefault(''),
		currencyType: parseAsString.withOptions({ shallow: false }).withDefault(''),
	})

	// Debounce search query for better performance
	const [debouncedQuery] = useDebounceValue(queryParams.q, 500)

	const query = {
		take: queryParams.limit,
		skip: (queryParams.page - 1) * queryParams.limit,
		search: debouncedQuery || undefined,
		status: ShopHistoryStatus.PENDING,
		currencyType:
			(queryParams.currencyType as components['schemas']['CurrencyType']) ||
			undefined,
	}

	const { data, isLoading } = useQueryGetShopPurchases(query)

	return (
		<PageContainer>
			<PurchasesListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

export default withUserPermission(PendingPurchasesPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_SHOP],
})
